import { useEffect, useState } from "react";

/** Debounce di un valore (300ms sulla ricerca): al mount ritorna il valore
 *  iniziale senza attendere, così la prima fetch parte subito.
 *
 *  Copia unica, usata da ClientiPage e FatturazionePage. */
export function useDebounced<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
